import React from 'react';
import ReactDOM from 'react-dom';
import { useSelectContext } from './SelectContext';
import { cn } from '../../utils';

interface SelectContentProps {
  children: React.ReactNode;
  className?: string;
}

export const SelectContent: React.FC<SelectContentProps> = ({
  children,
  className,
}) => {
  const { isOpen, refs, x, y, strategy } = useSelectContext();

  if (!isOpen) {
    return null;
  }

  return ReactDOM.createPortal(
    <div
      ref={refs.setFloating}
      className={cn(
        'bg-white rounded-lg shadow-lg z-50 overflow-auto',
        className,
      )}
      style={{
        position: strategy,
        top: y ?? 0,
        left: x ?? 0,
        maxHeight: '320px',
        width: '280px',
      }}
      role="listbox"
    >
      {children}
    </div>,
    document.body,
  );
};
